var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconButton",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('img', {
    staticClass: "iconButton__image",
    attrs: {
      "src": _vm.iconSrc || _vm.defaultSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconButton__aura",
    class: {
      expand: _vm.clicked
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09218c92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/IconButton.vue
// module id = 3LmT
// module chunks = 1